/**
 * Aviso de presentación: una pastilla centrada arriba que dice qué está pasando
 * y deja salir de un toque. Solo aparece cuando hay algo que contar.
 */
import type { App } from '../app.ts'
import { h } from './dom.ts'
import { icon } from './icons.ts'

export class PresentBar {
  readonly el: HTMLElement
  private app: App
  private label: HTMLElement
  private action: HTMLButtonElement

  constructor(app: App) {
    this.app = app
    this.label = h('span', { class: 'present-label' })
    this.action = h('button', { class: 'present-action', onclick: () => this.onAction() }) as HTMLButtonElement
    this.el = h('div', { class: 'present-bar hidden' }, [
      h('span', { class: 'present-dot' }),
      this.label,
      this.action,
    ])
  }

  render(): void {
    const present = this.app.presentation
    const presenter = present.presenter

    if (present.presenting) {
      this.show('is-live', 'Presentando · las demás pantallas te siguen', 'Terminar')
      return
    }

    if (presenter && this.app.store.followingUser === presenter.id) {
      this.show('is-following', `Siguiendo a ${presenter.name}`, 'Salir')
      return
    }

    if (presenter) {
      this.show('is-paused', `${presenter.name} está presentando`, 'Seguir')
      return
    }

    this.el.className = 'present-bar hidden'
  }

  private show(variant: string, text: string, action: string): void {
    this.el.className = `present-bar ${variant}`
    this.label.textContent = text
    this.action.textContent = action
  }

  private onAction(): void {
    const present = this.app.presentation
    if (present.presenting) present.stopPresenting()
    else if (this.app.store.followingUser) present.leave()
    else present.rejoin()
  }
}

/** Botón de la barra superior para empezar o terminar la presentación. */
export function presentButton(app: App): HTMLButtonElement {
  const btn = h('button', {
    class: 'tbtn present-btn',
    title: 'Presentar: las demás pantallas siguen tu vista',
    'aria-label': 'Presentar',
    onclick: () => {
      app.presentation.togglePresenting()
      sync()
    },
  }) as HTMLButtonElement
  const sync = (): void => {
    btn.innerHTML = icon(app.presentation.presenting ? 'present-off' : 'present', 18)
    btn.classList.toggle('is-live', app.presentation.presenting)
    btn.title = app.presentation.presenting
      ? 'Terminar la presentación'
      : 'Presentar: las demás pantallas siguen tu vista'
  }
  sync()
  btn.dataset.sync = '1'
  ;(btn as HTMLButtonElement & { sync: () => void }).sync = sync
  return btn
}
